import { ref, computed } from 'vue';
import type { Ref } from 'vue';

export default function handleValidation<T>(objectToValidate: Ref<T>) {
  const errors = ref<Record<string, string>>({});
  const errorHasOccurred = ref(false);

  function clearErrors() {
    errors.value = {};
    errorHasOccurred.value = false;
  }

  function setErrors(newErrors: Record<string, string>) {
    errors.value = newErrors;
    errorHasOccurred.value = true;
  }

  function getError(field: string) {
    if (!errors.value || !errors.value[field]) {
      return '';
    }
    return errors.value[field];
  }

  function hasError(field: string) {
    return !!errors.value[field];
  }

  const validate = computed(() => {
    if (!errorHasOccurred.value || !errors.value || !objectToValidate.value) {
      return [];
    }

    const newErrors: string[] = [];
    for (const error in errors.value) {
      const errorKey = error as keyof T;
      if (objectToValidate.value[errorKey] !== undefined && newErrors.indexOf(error) == -1) {
        newErrors.push(error);
      }
    }
    return newErrors;
  });

  function removeError(field: string) {
    if (errors.value[field]) {
      delete errors.value[field];
    }
  }

  return {
    errors,
    errorHasOccurred,
    clearErrors,
    setErrors,
    getError,
    hasError,
    removeError,
    validate,
  };
}
